import React from 'react';
import { useNavigate } from 'react-router-dom';

import { changeDateFormat, convertNumberToUSFormat, getActionDoneBy } from '@utils/Util';

const CostingCard = ({ costingItem }) => {
	const navigate = useNavigate();
	return (
		<div className="sample-single-item costing" key={costingItem.id}>
			<div className="container-fluid">
				<div className="row">
					<div
						className="col-sm-6 col-md-5 col-lg-5 col-xl-4 one-sixth pl-0"
						onClick={() => {
							navigate(`/costing/${costingItem.id}`);
						}}
					>
						<div className="d-flex align-items-center">
							<div className="product-img-container">
								<div className="prev-img">
									<img
										src={
											costingItem?.productFeatureImageList?.[0] ||
											`${process.env.PUBLIC_URL}/images/default_product.svg`
										}
										alt="image"
									/>
								</div>
								<div className="prev-img-thumb">
									<div className="single-first">
										<img
											src={
												costingItem?.productFeatureImageList?.[1] ||
												`${process.env.PUBLIC_URL}/images/default_product.svg`
											}
											alt="image"
										/>
									</div>
									<div className="single-second">
										<img
											src={
												costingItem?.productFeatureImageList?.[2] ||
												`${process.env.PUBLIC_URL}/images/default_product.svg`
											}
											alt="image"
										/>
									</div>
								</div>
							</div>
							<div className="contents pl-3">
								<p className="medium-14 gray_dark_01 mb-1">
									{costingItem?.title || costingItem?.collectionName}{' '}
								</p>
								<ul className="common-list-component mb-2">
									<li className="weight-500 gray_dark_01">{costingItem?.requestedBy} </li>
									<li>{costingItem?.referenceNumber}</li>
									{/* <li>{costingItem.noOfDesign} designs</li> */}
								</ul>
								<span className="brand-common-design mr-2">{costingItem?.brandName}</span>
								{!costingItem.isViewed && <span className="new-tag ml-1">NEW</span>}
							</div>
						</div>
					</div>

					<div
						className="col-sm-6 col-md-6 col-lg-6 col-xl-5 one-sixth request-info-date-details"
						onClick={() => navigate(`/costing/${costingItem.id}`)}
					>
						<div className="d-flex justify-content-center after-boder">
							<div className="mr-4 req-costing-info">
								<p className="regular-12 gray_dark_02">
									<span className="info-label">Design</span>
									<span className="gray_dark_01 ml-2">{costingItem.noOfDesign}</span>
								</p>
								<p className="regular-12 gray_dark_02">
									<span className="info-label">Qty</span>
									<span className="gray_dark_01 ml-2">
										{convertNumberToUSFormat(costingItem?.totalQuantity, true)}
									</span>
								</p>
								<p className="regular-12">
									<span className="gray_dark_02 mr-1 info-label">Price</span>
									<span className="gray_dark_01">
										{' '}
										${parseFloat(costingItem?.totalPrice).toFixed(2)}
									</span>
								</p>
							</div>
							<div
								className="expected-dates ml-1"
								onClick={() => navigate(`/costing/${costingItem.id}`)}
							>
								<p className="regular-12 gray_dark_02">
									<span>Requested</span>
									<span className="gray_dark_01 ml-2">
										{changeDateFormat(costingItem?.requestedDate, '', 'Do MMM, YYYY')}
									</span>
								</p>
								<p className="regular-12 gray_dark_02">
									<span>Required</span>
									<span className="gray_dark_01 ml-2">
										{changeDateFormat(costingItem?.requiredDate, '', 'Do MMM, YYYY')}
									</span>
								</p>
								{costingItem?.estimatedOrderDeliveryDate && (
									<p className="regular-12 gray_dark_02">
										<span>Order ETD</span>
										<span className="gray_dark_01 ml-2">
											{changeDateFormat(
												costingItem?.estimatedOrderDeliveryDate,
												'',
												'Do MMM, YYYY'
											)}
										</span>
									</p>
								)}
							</div>
						</div>
					</div>
					<div
						className="col-sm-12 col-md-12 col-lg-2 col-xl-3 one-sixth"
						onClick={() => navigate(`/costing/${costingItem.id}`)}
					>
						<div className="sample-status">
							{costingItem?.statusCountList?.map((item) => {
								const statusMap = {
									INITIALIZED: { class: '', text: ' Quote Requested' },
									OFFER_SENT: { class: 'send', text: 'Offer sent' },
									APPROVED: { class: 'approved', text: 'Approved' },
									QUOTED: { class: 'quote', text: 'Costing Done' },
									REJECTED: { class: 'quote', text: 'Rejected' },
									FACTORY_COSTING: { class: 'costing', text: 'Factory Costing' }
								};
								const statusInfo = statusMap[item?.status];

								if (!statusInfo) return null;

								const { class: statusClass, text: statusText } = statusInfo;
								return (
									item?.count > 0 && (
										<span className={`status ${statusClass}`} key={item.status}>
											{statusText} {getActionDoneBy(item?.userType)}{' '}
											<span>{item?.count}</span>
										</span>
									)
								);
							})}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CostingCard;
